import React, { useState } from 'react';
import { XIcon, SendIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const Footer = () => {
  const navigate = useNavigate();
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    questionType: '',
    message: ''
  });
  const handleOpenContactForm = e => {
    e.preventDefault();
    setShowContactForm(true);
  };
  const handleCloseContactForm = () => {
    setShowContactForm(false);
    // Reset form data
    setFormData({
      questionType: '',
      message: ''
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here you would send the form data to your backend
    alert(`Form submitted!\nQuestion Type: ${formData.questionType}\nMessage: ${formData.message}`);
    handleCloseContactForm();
  };
  return <footer className="bg-[#333333] text-white py-12" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex flex-col md:flex-row items-start justify-between" data-id="element-162">
          <div className="md:w-2/3" data-id="element-163">
            <div className="flex items-center mb-6 justify-start -mt-8" data-id="element-164">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nMSpntRNnXAqcKqNNFaLt4/Final_Emigo_Logo_%28Transparent%29-Photoroom.png" alt="Emigo Logo" className="h-48 w-auto" data-id="element-165" />
            </div>
            <div className="flex flex-col md:flex-row md:items-center md:space-x-8 mb-6" data-id="element-166">
              <a href="#faq" className="text-gray-400 hover:text-white transition-colors mb-2 md:mb-0" onClick={e => {
              e.preventDefault();
              const faqElement = document.getElementById('faq');
              if (faqElement) {
                faqElement.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} data-id="element-167">
                FAQ
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors mb-2 md:mb-0" onClick={handleOpenContactForm} data-id="element-168">
                Contact Us
              </a>
              <button onClick={() => navigate('/privacy-policy')} className="text-gray-400 hover:text-white transition-colors mb-2 md:mb-0 text-left" data-id="element-169">
                Privacy Policy
              </button>
              <button onClick={() => navigate('/terms-of-service')} className="text-gray-400 hover:text-white transition-colors mb-2 md:mb-0 text-left" data-id="element-170">
                Terms of Service
              </button>
            </div>
            <div className="flex space-x-4" data-id="element-171">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-172">
                <span className="sr-only" data-id="element-173">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-174">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-175" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-176">
                <span className="sr-only" data-id="element-177">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-178">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-179" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-180">
                <span className="sr-only" data-id="element-181">Reddit</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-182">
                  <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" data-id="element-183" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-184">
                <span className="sr-only" data-id="element-185">TikTok</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-186">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-187" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm" data-id="element-188">
          <p data-id="element-189">&copy; {new Date().getFullYear()} Emigo. All rights reserved.</p>
        </div>
      </div>
      {/* Contact Form Popup */}
      {showContactForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-190">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 animate-popup" data-id="element-191">
            <div className="flex justify-between items-center mb-6" data-id="element-192">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-193">Contact Us</h2>
              <button onClick={handleCloseContactForm} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-194">
                <XIcon className="w-5 h-5" data-id="element-195" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-196">
              <div data-id="element-197">
                <label htmlFor="questionType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-198">
                  Type of Question
                </label>
                <select id="questionType" name="questionType" value={formData.questionType} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" required data-id="element-199">
                  <option value="" disabled data-id="element-200">
                    Select question type
                  </option>
                  <option value="general" data-id="element-201">General Inquiry</option>
                  <option value="technical" data-id="element-202">Technical Support</option>
                  <option value="billing" data-id="element-203">Billing Question</option>
                  <option value="feature" data-id="element-204">Feature Request</option>
                  <option value="feedback" data-id="element-205">Feedback</option>
                </select>
              </div>
              <div data-id="element-206">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-207">
                  Your Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} rows={5} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" placeholder="Please describe your question or issue..." required data-id="element-208"></textarea>
              </div>
              <div className="flex justify-end space-x-3 pt-2" data-id="element-209">
                <button type="button" onClick={handleCloseContactForm} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-210">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white rounded-md hover:opacity-90 transition-colors flex items-center" data-id="element-211">
                  Submit
                  <SendIcon className="ml-2 h-4 w-4" data-id="element-212" />
                </button>
              </div>
            </form>
          </div>
        </div>}
    </footer>;
};
export default Footer;